module.exports = __webpack_public_path__ + "static/media/LocationIcon.feee6d64.svg";